import api from './base'
import { ApiResponse } from './index'
import {
    User,
    AuthResponse,
    LoginCredentials,
    RegisterData,
    UpdateDetailsData,
    UpdatePasswordData
} from '@/types/auth'

export const authApi = {
    // Authentication endpoints
    login: (credentials: LoginCredentials): Promise<ApiResponse<AuthResponse>> =>
        api.post('/auth/login', credentials),

    register: (userData: RegisterData): Promise<ApiResponse<AuthResponse>> =>
        api.post('/auth/register', userData),

    logout: (): Promise<ApiResponse> =>
        api.post('/auth/logout'),

    refreshToken: (): Promise<ApiResponse<AuthResponse>> => {
        const refreshToken = localStorage.getItem('refreshToken')
        return api.post('/auth/refresh', { refreshToken })
    },

    // User profile endpoints
    getMe: (): Promise<ApiResponse<{ user: User }>> =>
        api.get('/auth/me'),

    updateDetails: (userData: UpdateDetailsData): Promise<ApiResponse<{ user: User }>> =>
        api.put('/auth/update-details', userData),

    updatePassword: (passwords: UpdatePasswordData): Promise<ApiResponse<{ token: string; refreshToken: string }>> =>
        api.put('/auth/update-password', passwords),

    // Password recovery endpoints
    forgotPassword: (email: string): Promise<ApiResponse> =>
        api.post('/auth/forgot-password', { email }),

    resetPassword: (token: string, password: string): Promise<ApiResponse<AuthResponse>> =>
        api.put(`/auth/reset-password/${token}`, { password }),

    // Email verification endpoints
    verifyEmail: (payload: { email: string; code: string }): Promise<ApiResponse<{ message: string }>> =>
        api.post('/auth/verify-email', payload),

    resendVerification: (): Promise<ApiResponse> =>
        api.post('/auth/resend-verification'),

    // Account management
    deleteAccount: (password: string): Promise<ApiResponse> =>
        api.delete('/auth/account', { data: { password } }),

    // Social login (future implementation)
    googleLogin: (token: string): Promise<ApiResponse<AuthResponse>> =>
        api.post('/auth/google', { token }),

    // Two-factor authentication (future implementation)
    enable2FA: (): Promise<ApiResponse<{ qrCode: string; secret: string }>> =>
        api.post('/auth/2fa/enable'),

    verify2FA: (code: string): Promise<ApiResponse> =>
        api.post('/auth/2fa/verify', { code }),

    disable2FA: (password: string): Promise<ApiResponse> =>
        api.post('/auth/2fa/disable', { password }),
}